// this reducer stores the current page, and previous pages
// this is useful for the bottom tabs to know what page they are on
// it is also used for debugging

import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  currentScreen: 'AppLoadingPage',
  previousScreen: 'AppLoadingPage',
  previousPreviousScreen: 'AppLoadingPage',
  alertOpen: 0, //this is used by global.devAlert to only allow one alert to open at a time
  loadingIndicatorOpen: 0,
  previousVisit: 0,
  delayedDeepLink: null,
  hasSeenTurtorial: 0,
  currentScreenChanges: 0,
  roundedCurrentScreenChanges: 0,
  hasCameraPermisson: 0,
  photoTaken: 0,
  firebaseListeners: {},
  isDrawerOpen: 0,
  appStateVisible: 'unkown', // active, background, inactive, unkown
};

// test
const currentScreenSlice = createSlice({
  name: 'current_screen',
  initialState,
  reducers: {
    // this is updated by the drawer.js navigation wrapper
    setCurrentScreen(state, {payload: currentScreen}) {
      if (currentScreen != state.currentScreen) {
        try {
          state.currentScreenChanges = state.currentScreenChanges + 1;

          state.roundedCurrentScreenChanges = Math.floor(
            state.currentScreenChanges / 10,
          );
          // console.log({
          //   currentScreenChanges: state.currentScreenChanges,
          //   roundedCurrentScreenChanges: state.roundedCurrentScreenChanges,
          // });
        } catch (e) {
          window.devAlert('Could not log screen changes');
          state.currentScreenChanges = 0;
          state.roundedCurrentScreenChanges = 0;
        }
      }
      state.previousPreviousScreen = state.previousScreen;
      state.previousScreen = state.currentScreen;
      state.currentScreen = currentScreen;
    },
    // this is fired in global.devAlert
    setAlertOpen(state, {payload: alertOpen}) {
      state.alertOpen = alertOpen;
    },
    setPreviousVisit(state, {payload: previousVisit}) {
      state.previousVisit = previousVisit;
    },
    // this is fired to show a loading screen
    setLoadingIndicatorOpen(state, {payload: loadingIndicatorOpen}) {
      console.log('setLoadingIndicatorOpen', {loadingIndicatorOpen});
      state.loadingIndicatorOpen = loadingIndicatorOpen;
    },
    setDelayedDeepLink(state, {payload: delayedDeepLink}) {
      state.delayedDeepLink = delayedDeepLink;
    },
    setHasSeenTurtorial(state, {payload: hasSeenTurtorial}) {
      console.log('setHasSeenTurtorial');
      state.hasSeenTurtorial = hasSeenTurtorial;
    },
    setHasCameraPermissions(state, {payload: hasCameraPermisson}) {
      console.log('setHasCameraPermissions');
      state.hasCameraPermisson = hasCameraPermisson;
    },
    setPhotoTaken(state, {payload: photoTaken}) {
      console.log('setPhotoTaken: ', {photoTaken});
      state.photoTaken = photoTaken;
    },
    saveFirebaseListener(state, {payload: listener}) {
      console.log('saveFirebaseListener ' + listener);
      const newFirebaseListeners = {
        ...state.firebaseListeners,
        ...listener,
      };
      console.log({newFirebaseListeners});
      state.firebaseListeners = newFirebaseListeners;
    },
    deleteFirebaseListener(state, {payload: listenerId}) {
      console.log('deleteFirebaseListener ' + listenerId);
      const newFirebaseListeners = {...state.firebaseListeners};
      delete newFirebaseListeners[listenerId];
      console.log({newFirebaseListeners});
      state.firebaseListeners = newFirebaseListeners;
    },
    setIsDrawerOpen(state, {payload: isDrawerOpen}) {
      console.log('setIsDrawerOpen ' + isDrawerOpen);
      state.isDrawerOpen = isDrawerOpen;
    },
    setReduxAppStateVisible(state, {payload: appStateVisible}) {
      console.log('setReduxAppStateVisible ' + appStateVisible);
      state.appStateVisible = appStateVisible;
    },
  },
});

export const {
  setCurrentScreen,
  setAlertOpen,
  setLoadingIndicatorOpen,
  setDragableDefualt,
  setPreviousVisit,
  setDelayedDeepLink,
  setHasSeenTurtorial,
  setHasCameraPermissions,
  setPhotoTaken,
  saveFirebaseListener,
  deleteFirebaseListener,
  setIsDrawerOpen,
  setReduxAppStateVisible,
} = currentScreenSlice.actions;

export default currentScreenSlice.reducer;
